import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Flashcard } from 'src/app/models/flashcard.model';

@Component({
  selector: 'app-flashcard-widget',
  templateUrl: './flashcard-widget.component.html',
  styleUrls: ['./flashcard-widget.component.scss'],
  standalone: false
})
export class FlashcardWidgetComponent {

  @Input() flashcard!: Flashcard;
  @Input() hideDueDate: boolean = false;

  @Input() hideActions: boolean = false;
  @Input() hideEdit: boolean = false;
  @Output() actionsClicked: EventEmitter<Flashcard> = new EventEmitter<Flashcard>();
  @Output() actionClicked: EventEmitter<string> = new EventEmitter<string>();

  todaysDate: Date = new Date();

  constructor() {}

  ngOnInit() {
  }

  handleActionsClick() {
    this.actionsClicked.emit(this.flashcard);
  }

  handleActionClicked(action: string) {
    this.actionClicked.emit(action);
  }
}
